<template>
  <div
    class="modal fade"
    id="filterModal"
    tabindex="-1"
    aria-labelledby="filterModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-title" id="filterModalLabel">Filter</h5>
          <button
            type="button"
            class="btn-close p-0"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <img src="../../assets/img/icons/close-circle-2.svg" alt="Image" />
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="applyFilter">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group mb-15">
                  <label class="d-block fs-14 text-black mb-10">Customer</label>
                  <select
                    v-model="filters.customer_id"
                    class="bg_ash border-0 rounded-1 fs-14 text-optional w-100 p-2"
                  >
                    <option value="">All Customers</option>
                    <option
                      v-for="customer in customers"
                      :key="customer.id"
                      :value="customer.id"
                    >
                      {{ customer.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-15">
                  <label class="d-block fs-14 text-black mb-10">Warehouse</label>
                  <select
                    v-model="filters.warehouse_id"
                    class="bg_ash border-0 rounded-1 fs-14 text-optional w-100 p-2"
                  >
                    <option value="">All Warehouses</option>
                    <option
                      v-for="warehouse in warehouses"
                      :key="warehouse.id"
                      :value="warehouse.id"
                    >
                      {{ warehouse.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-15">
                  <label class="d-block fs-14 text-black mb-10">Reference No</label>
                  <input
                    v-model="filters.reference_no"
                    type="text"
                    class="w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-black border-0 placeholder-1 p-2"
                    placeholder="Enter Reference No"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-15">
                  <label class="d-block fs-14 text-black mb-10">Status</label>
                  <select
                    v-model="filters.status"
                    class="bg_ash border-0 rounded-1 fs-14 text-optional w-100 p-2"
                  >
                    <option value="">All Status</option>
                    <option value="Completed">Completed</option>
                    <option value="Pending">Pending</option>
                  </select>
                </div>
              </div>

              <div class="col-lg-6 mb-md-15">
                <button
                  type="button"
                  class="btn style-four w-100 d-block"
                  data-bs-dismiss="modal"
                  @click="resetFilter"
                >
                  Reset
                </button>
              </div>
              <div class="col-lg-6">
                <button
                  type="submit"
                  class="btn style-five w-100 d-block"
                  data-bs-dismiss="modal"
                >
                  Apply Filter
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import customerService, { Customer } from "../../services/customer";
import warehouseService, { Warehouse } from "../../services/warehouse";

export default defineComponent({
  name: "FilterModal",
  emits: ["filter"],
  setup(_, { emit }) {
    const customers = ref<Customer[]>([]);
    const warehouses = ref<Warehouse[]>([]);
    const filters = ref({
      customer_id: "",
      warehouse_id: "",
      reference_no: "",
      status: "",
    });

    const fetchFilterData = async () => {
      try {
        const [customerData, warehouseData] = await Promise.all([
          customerService.getCustomers(),
          warehouseService.getWarehouses(),
        ]);
        customers.value = customerData;
        warehouses.value = warehouseData;
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    const applyFilter = () => {
      emit("filter", { ...filters.value });
    };

    const resetFilter = () => {
      filters.value = {
        customer_id: "",
        warehouse_id: "",
        reference_no: "",
        status: "",
      };
      emit("filter", { ...filters.value });
    };

    onMounted(fetchFilterData);

    return {
      customers,
      warehouses,
      filters,
      applyFilter,
      resetFilter,
    };
  },
});
</script>

<style scoped>
.form-group select,
.form-group input {
  height: 50px;
}
</style>